import { CSSProperties } from 'react';

export const defaultStylesIcon: CSSProperties = {
  fontSize: 14,
  color: '#192A4D',
};
